export const colaboratorNameFormatter = currentName => {
    if (currentName) {
        const name = currentName.split(',');

        return name[0];
    }

    return null;
};

export const colaboratorsFormatter = (collaborators, card) => {
    const names = collaborators?.map(collaborator =>
        collaborator.name?.split(' ').slice(0, 3).join(' ').replace(/,/, '')
    );

    if (!collaborators) {
        return `Por Equipe Lupa`;
    }

    if (card) {
        if (collaborators?.length <= 0) {
            return '';
        } else if (collaborators?.length >= 2) {
            return `Por Equipe Lupa`;
        } else {
            return `Por ${names?.[0]}`;
        }
    } else {
        if (collaborators?.length > 0 && collaborators?.length <= 2) {
            return `Por ${names.join(' e ')}`;
        }

        if (collaborators?.length > 2) {
            return `Por Equipe Lupa`;
        }
    }

    return null;
};
